import TreeGrid from "./treeGrid";

export default class SimpleTreeGrid extends TreeGrid {
    constructor(props) {
        super(props);
    }
}